export default __webpack_public_path__ + "static/media/bild_charity_web.4dbfae82.jpg";